import SideOnDiagram from './side-on/SideOnDiagram'
import TopDownDiagram from './top-down/TopDownDiagram'

const properties = {
  svgHeight: 140,
  svgWidth: 270,
  yOffset: 10,
  sideDiagramXOffset: 200,
}

const GeometryDiagram = () => {
  return (
    <svg height={properties.svgHeight} width={properties.svgWidth}>
      <TopDownDiagram yOffset={properties.yOffset} />
      <SideOnDiagram xOffset={properties.sideDiagramXOffset} yOffset={properties.yOffset} />
    </svg>
  )
}

export default GeometryDiagram
